var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"pa-0 pr-1",attrs:{"cols":_vm.cols}},[_c('v-subheader',{staticStyle:{"height":"auto","min-height":"48px"}},[_c('span',[_vm._v("\n      "+_vm._s(_vm.attribute[`label_${_vm.$i18n.locale}`] ||
      'No translation')+"\n      ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }